module.exports = require("es-toolkit/predicate");